import { Checkbox } from "antd";
import useKeypress from "react-use-keypress";
import useAdBlockStore from "store/AdBlockStore";
import { LabelledSelect, LabelledInput } from "../Fields";
import { INIT_INCENTIVE_TEXT, INCENTIVE_TYPE_DATA, INCENTIVE_ATTACH_TO_DATA } from "config";


export const IncentiveBuilder = () => {
  const currentOffer = useAdBlockStore((state) => state.currentOffer);
  const updateCurrentIncentive = useAdBlockStore((state) => state.updateCurrentIncentive);
  const setActiveField = useAdBlockStore((state) => state.setActiveField);
  const focusPreviousField = useAdBlockStore((state) => state.focusPreviousField);
  const focusNextField = useAdBlockStore((state) => state.focusNextField);

  useKeypress(['Tab'], (event) => {
    if (event.shiftKey) {
      focusPreviousField("incentive-builder", event);
      return;
    }
    focusNextField("incentive-builder", event);
  });

  return (
    <span id="incentive-builder" className="incentive-builder">
      <LabelledSelect type={"inline"} variant="filled"
        label="Incentive Type" placeholder="Select Incentive Type"
        options={
          INCENTIVE_TYPE_DATA.map(item => ({
            label: item.title,
            value: item.id,
          }))
        }
        value={currentOffer?.incentive_type || ""}
        onFocus={() => setActiveField("incentive_type")}
        onChange={(value) => {
          if (value) {
            setTimeout(() => {
              updateCurrentIncentive({
                incentive_text: value && INIT_INCENTIVE_TEXT[value],
                incentive_type: value
              })
            }, 300)
          }
        }}
      />
      <LabelledInput label="Incentive Text" placeholder="Incentive Text"
        allowclear="true" value={currentOffer?.incentive_text || ""}
        onFocus={() => {
          useAdBlockStore.setState({ leftPanelView: "incentive_text" });
          setActiveField("incentive_text");
        }}
        onChange={(val) => {
          updateCurrentIncentive({ incentive_text: val })
        }}
      />
      <div className="d-flex justify-content-between align-items-center" style={{ width: '100%' }}>
        <div style={{ width: '29%' }}>
          <LabelledSelect variant="filled" allowClear
            label="Attached To" placeholder="Attached To"
            onFocus={() => setActiveField("incentive_attach_to")}
            options={
              INCENTIVE_ATTACH_TO_DATA.map(item => ({
                label: item.title,
                value: item.id,
              }))
            }
            value={currentOffer?.incentive_attach_to}
            onChange={(value) => {
              updateCurrentIncentive({ incentive_attach_to: value })
            }}
          />
        </div>
        <div style={{ width: '69%' }}>
          <LabelledInput label="Limit" placeholder="Limit"
            allowclear="true" inputType="float"
            value={currentOffer?.incentive_limit || ""}
            onChange={(val) => updateCurrentIncentive({ incentive_limit: val })}
          // onFocus={() => setActiveField("limit")}
          />
        </div>

      </div>
      <Checkbox checked={currentOffer?.incentive_include_net_cost}
        onChange={(e) => updateCurrentIncentive({ incentive_include_net_cost: e.target.checked })}
        onFocus={() => setActiveField("none")} >
        Include in Net Cost
      </Checkbox>
      <Checkbox checked={currentOffer?.incentive_by_mail}
        onChange={(e) => updateCurrentIncentive({ incentive_by_mail: e.target.checked })}
        onFocus={() => setActiveField("none")} >
        By Mail
      </Checkbox>
      <Checkbox checked={currentOffer?.incentive_online_incentive}
        onChange={(e) => updateCurrentIncentive({ incentive_online_incentive: e.target.checked })}
        onFocus={() => setActiveField("none")} >
        Online Incentive
      </Checkbox>
      <Checkbox checked={currentOffer?.incentive_liner_f}
        onChange={(e) => updateCurrentIncentive({ incentive_liner_f: e.target.checked })}
        onFocus={() => setActiveField("none")} >
        Liner
      </Checkbox>      
    </span>
  )
}